import type { Nullable } from '@immersive-tech/viewer-engine';

export const sha1 = async (byteBuffer: ArrayBuffer) => {
  try {
    const hash = await crypto.subtle.digest('SHA-1', byteBuffer);
    const bytes = new Uint8Array(hash);

    return bytes.reduce((output, byte) => {
      return output + byte.toString(16).padStart(2, '0');
    }, '');
  } catch (err) {
    console.log(err);
    return '00';
  }
};

export const generateUniqueKey = (source: string[], proposedKey: string, appendStartingNumber = 1) => {
  let uniqueIndex = appendStartingNumber;
  let existingKey = undefined;
  let uniqueKey = proposedKey;

  do {
    existingKey = source.find((elm) => elm === uniqueKey);

    if (existingKey) {
      uniqueKey = `${proposedKey}_${uniqueIndex}`;
      uniqueIndex += 1;
    }
  } while (existingKey !== undefined);

  return uniqueKey;
};

export const isValidJSON = (input: string) => {
  try {
    JSON.parse(input);

    return true;
  } catch (err) {
    return false;
  }
};

export const checkPerformance = (label: string, callback: Nullable<(() => unknown)>) => {
  const startTime = performance.now();

  if (callback) callback();

  const endTime = performance.now();

  console.log(label, endTime - startTime);
};
